import motionE20 from '../../../img/productPhotos/motionE20.jpg'
import { productPhotoMap } from '../../../img/productPhotos/productPhotoMap'

// Line-up tiles mirror the live app catalog (Firebase Misc/env/security_*,
// read 2026-10-09): every `type` is an exact catalog product string, so the
// viewer opens the same product the rep can sell. `label` is the short tile
// caption from Jaron's Oct 8 marked sheet (ticket 13241344427).
export interface ProductLineupTile {
  label: string
  /** Exact Firebase product `type`, the key of the photo / media maps. */
  type: string
  /** Tile + viewer photo override when the catalog photo is not the right model. */
  photo?: string
}

export interface ProductLineupSection {
  title: string
  tiles: readonly ProductLineupTile[]
}

export const PRODUCT_LINEUP_SECTIONS: readonly ProductLineupSection[] = [
  {
    title: 'CCTV Cameras',
    tiles: [
      { label: 'S4 Max', type: 'S4 Max Camera (PoE)' },
      { label: 'Bullet Cam E40', type: 'Bullet Cam E40 (PoE)' },
      { label: 'Turret E41', type: 'Turret E41 (PoE)' },
      { label: 'NVR 2TB–16TB', type: 'NVR (Network Video Recorder)' },
    ],
  },
  {
    title: 'WiFi Cameras',
    tiles: [
      { label: 'S4 Wireless Cam', type: 'Solar S4 Camera' },
      { label: 'SoloCam S340', type: 'Solar S340 Camera' },
      { label: 'SoloCam S220', type: 'SoloCam S220' },
      { label: 'Indoor Cam E220', type: 'Indoor Camera E220' },
      { label: 'Indoor Cam S350', type: 'Indoor Camera S350' },
      { label: 'Doorbell E340', type: 'Doorbell E340' },
      { label: 'HomeBase 3', type: 'HomeBase 3' },
    ],
  },
  {
    // Jaron wrote "Alarm" on the sheet, but "alarm" (Monday 12824335937) and
    // "security" (T56) are both banned on customer surfaces. "Smart Home" is
    // what the Job Summary and the contract already show for security_system
    // (Summary/Cost.tsx).
    title: 'Smart Home',
    tiles: [
      { label: 'Smart Panel', type: 'Smart Panel' },
      { label: 'Keypad', type: 'Keypad' },
      { label: 'Key Fob E10', type: 'eufy Key Fob E10' },
      { label: 'Entry Sensor', type: 'Door Sensors' },
      // Official eufy.com photo (Motion Sensor E20, t90m0121), 2026-10-18.
      { label: 'Motion E20', type: 'Motion Detector', photo: motionE20 },
      { label: 'Glass Break Sensor', type: 'Glass Break Sensor' },
      { label: 'Smoke Sensor', type: 'Smoke' },
      { label: 'Panic / SOS', type: 'Medical Pendant' },
    ],
  },
  {
    title: 'Home Automation',
    tiles: [
      { label: 'Smart Lock C220', type: 'Smart Lock C220' },
      { label: 'FamiLock', type: 'FamiLock Doorbell + Lock' },
    ],
  },
]

export const lineupTilePhoto = (tile: ProductLineupTile): string =>
  tile.photo ?? productPhotoMap[tile.type] ?? ''
